import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { AutoComplete, ListEditable, TextArea } from '../../../../../../../components'
import {
  COUNTRY,
  REGION,
  CUSTOM_REGION,
  SECTOR,
  SECURITYTYPE,
  STYLE,
  MARKETCAP,
  QUALITY,
  STRATEGY
} from '../../../../../../../utils'
import { groupBy } from 'lodash'

/**
 * Strategy
 */
class Strategy extends PureComponent {
  /**
   * ComponentDidMount
   */
  componentDidMount () {
    const { jobStrategy, onValueChange } = this.props
    const { country, region_group, custom_region, sectors, security_type, style, market_cap, quality, strategy } = jobStrategy

    onValueChange(this.getList(country, COUNTRY), 'country')
    onValueChange(this.getList(region_group, REGION), 'region_group')
    onValueChange(this.getList(custom_region, CUSTOM_REGION), 'custom_region')
    onValueChange(this.getList(sectors, SECTOR), 'sectors')
    onValueChange(this.getList(security_type, SECURITYTYPE), 'security_type')
    onValueChange(this.getList(style, STYLE), 'style')
    onValueChange(this.getList(market_cap, MARKETCAP), 'market_cap')
    onValueChange(this.getList(quality, QUALITY), 'quality')
    onValueChange(this.getList(strategy, STRATEGY), 'strategy')
  }

  /**
   * Prepopulate list on Edit
   * @param options
   * @param LIST
   * @returns {*[]}
   */
  getList = (options, LIST) => {
    const existing = (LIST || [])
      .filter((option) => (options || []).includes(option.value))

    const values = groupBy(LIST, (option) => (option && option.value))
    const outside = (options || [])
      .filter((option) => option && !values[option])
      .map((option) => {
        return {
          label: option,
          value: option
        }
      })

    return [].concat(outside, existing)
  }

  /**
   * On list item delete
   * @param params
   */
  onDelete = (params) => {
    const { onValueChange } = this.props
    const { item, list, LIST, listName } = params

    const options = (list || [])
      .filter((option) => (option && option.value) !== (item && item.value))
      .map((option) => option && option.value)

    onValueChange(this.getList(options, LIST), listName)
  }

  /**
   * Render
   * @return {XML}
   */
  render () {
    const { current, onChange, onValueChange } = this.props
    const { country, region_group, custom_region, sectors, security_type, style, market_cap, quality, strategy, summary } = current

    return (
      <>
        <Grid item xs={12}>
          <div className='section_title'>Coverage/Strategy</div>
        </Grid>

        <Grid item xs={6} container spacing={3} direction='column'>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Country</label>
              <AutoComplete
                name='country'
                placeholder='Select'
                value={country}
                isMulti
                isDefaultList
                clearable={false}
                closeMenuOnSelect={false}
                options={COUNTRY}
                onChange={(option) => onValueChange(option, 'country')} />
            </div>
            <ListEditable
              listKey='value'
              items={country}
              onDelete={(item) => this.onDelete({
                item, list: country, LIST: COUNTRY, listName: 'country'
              })} />
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Custom Region</label>
              <AutoComplete
                name='custom_region'
                placeholder='Select'
                value={custom_region}
                isMulti
                isDefaultList
                clearable={false}
                closeMenuOnSelect={false}
                options={CUSTOM_REGION}
                onChange={(option) => onValueChange(option, 'custom_region')} />
            </div>
            <ListEditable
              listKey='value'
              items={custom_region}
              onDelete={(item) => this.onDelete({
                item, list: custom_region, LIST: CUSTOM_REGION, listName: 'custom_region'
              })} />
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Market Caps</label>
              <AutoComplete
                name='market_cap'
                placeholder='Select'
                value={market_cap}
                isMulti
                isDefaultList
                clearable={false}
                closeMenuOnSelect={false}
                options={MARKETCAP}
                onChange={(option) => onValueChange(option, 'market_cap')} />
            </div>
            <ListEditable
              listKey='value'
              items={market_cap}
              onDelete={(item) => this.onDelete({
                item, list: market_cap, LIST: MARKETCAP, listName: 'market_cap'
              })} />
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Quality</label>
              <AutoComplete
                name='quality'
                placeholder='Select'
                value={quality}
                isMulti
                isDefaultList
                clearable={false}
                closeMenuOnSelect={false}
                options={QUALITY}
                onChange={(option) => onValueChange(option, 'quality')} />
            </div>
            <ListEditable
              listKey='value'
              items={quality}
              onDelete={(item) => this.onDelete({
                item, list: quality, LIST: QUALITY, listName: 'quality'
              })} />
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Sectors</label>
              <AutoComplete
                name='sectors'
                placeholder='Select'
                value={sectors}
                isMulti
                isDefaultList
                clearable={false}
                closeMenuOnSelect={false}
                options={SECTOR}
                onChange={(option) => onValueChange(option, 'sectors')} />
            </div>
            <ListEditable
              listKey='value'
              items={sectors}
              onDelete={(item) => this.onDelete({
                item, list: sectors, LIST: SECTOR, listName: 'sectors'
              })} />
          </Grid>
        </Grid>

        <Grid item xs={6} container spacing={3} direction='column'>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Region</label>
              <AutoComplete
                name='region_group'
                placeholder='Select'
                value={region_group}
                isMulti
                isDefaultList
                clearable={false}
                closeMenuOnSelect={false}
                options={REGION}
                onChange={(option) => onValueChange(option, 'region_group')} />
            </div>
            <ListEditable
              listKey='value'
              items={region_group}
              onDelete={(item) => this.onDelete({
                item, list: region_group, LIST: REGION, listName: 'region_group'
              })} />
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Strategies</label>
              <AutoComplete
                name='strategy'
                placeholder='Select'
                value={strategy}
                isMulti
                isDefaultList
                clearable={false}
                closeMenuOnSelect={false}
                options={STRATEGY}
                onChange={(option) => onValueChange(option, 'strategy')} />
            </div>
            <ListEditable
              listKey='value'
              items={strategy}
              onDelete={(item) => this.onDelete({
                item, list: strategy, LIST: STRATEGY, listName: 'strategy'
              })} />
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Style</label>
              <AutoComplete
                name='style'
                placeholder='Select'
                value={style}
                isMulti
                isDefaultList
                clearable={false}
                closeMenuOnSelect={false}
                options={STYLE}
                onChange={(option) => onValueChange(option, 'style')} />
            </div>
            <ListEditable
              listKey='value'
              items={style}
              onDelete={(item) => this.onDelete({
                item, list: style, LIST: STYLE, listName: 'style'
              })} />
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Security Type</label>
              <AutoComplete
                name='security_type'
                placeholder='Select'
                value={security_type}
                isMulti
                isDefaultList
                clearable={false}
                closeMenuOnSelect={false}
                options={SECURITYTYPE}
                onChange={(option) => onValueChange(option, 'security_type')} />
            </div>
            <ListEditable
              listKey='value'
              items={security_type}
              onDelete={(item) => this.onDelete({
                item, list: security_type, LIST: SECURITYTYPE, listName: 'security_type'
              })} />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <div className='field field--text'>
            <label className='field_label'>Summary</label>
            <TextArea
              maxlength={700}
              rows={10}
              value={summary}
              onChange={onChange} />
          </div>
        </Grid>
      </>
    )
  }
}

Strategy.propTypes = {
  current: PropTypes.object,
  jobStrategy: PropTypes.object,
  onValueChange: PropTypes.func.isRequired
}

export default Strategy
